"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var Div_1 = __importDefault(require("../Div"));
var index_1 = __importDefault(require("../../../../images/misc/index"));
var columnData = [
    { id: 'name', label: 'Tuote' },
    { id: 'origin', label: 'Alkuperä' },
    { id: 'numbers', label: 'Erätunnus / Teurastettu / Leikattu' }
];
var generateTableStyles = function (tablesCount, tableIndex) {
    return tablesCount === 2 && typeof tableIndex === 'number'
        ? {
            borderCollapse: 'collapse',
            width: '100%',
            color: 'white',
            float: 'left',
            animation: 'fadeIn 2s',
            textAlign: 'left'
        }
        : {
            borderCollapse: 'collapse',
            width: '100%',
            color: 'white',
            float: 'left',
            animation: 'fadeIn 2s',
            textAlign: 'left'
        };
};
var ItemTable = function (_a) {
    var items = _a.items, tablesCount = _a.tablesCount, tableIndex = _a.tableIndex;
    return (react_1.default.createElement(material_1.Grid, { item: true, xs: tablesCount === 2 ? 6 : 12 },
        react_1.default.createElement("table", { style: generateTableStyles(tablesCount, tableIndex) },
            react_1.default.createElement("thead", { style: tablesCount === 2 ? { verticalAlign: 'top' } : {} },
                react_1.default.createElement("tr", { style: { borderBottom: '1px solid white' } }, columnData.map(function (_a) {
                    var colId = _a.id, label = _a.label, extraLabel = _a.extraLabel;
                    return (react_1.default.createElement("th", { key: colId },
                        react_1.default.createElement("div", { style: {
                                fontWeight: 'bold',
                                fontSize: '1.1em',
                                textTransform: 'uppercase',
                                fontFamily: 'Skatta Sans Bold'
                            } }, label),
                        extraLabel && (react_1.default.createElement("div", { style: { fontStyle: 'italic', fontWeight: 'normal' } }, extraLabel))));
                }))),
            react_1.default.createElement("tbody", null, items.map(function (_a, i) {
                var productId = _a.productId, name = _a.name, origin = _a.origin, batchNumber = _a.batchNumber, slaughterId = _a.slaughterId, cutId = _a.cutId;
                return (react_1.default.createElement("tr", { key: "".concat(productId, "-").concat(i), style: {
                        borderBottom: '1px solid white',
                        height: 70
                    } },
                    react_1.default.createElement("th", { style: {
                            textTransform: 'uppercase',
                            fontWeight: 'bold',
                            fontFamily: 'Skatta Sans Bold',
                            width: tablesCount === 2 ? '420px' : '700px'
                        } }, name),
                    react_1.default.createElement("th", { style: tablesCount === 2
                            ? {
                                width: '140px'
                            }
                            : {} }, origin),
                    react_1.default.createElement("th", { style: tablesCount === 2
                            ? {
                                width: '350px'
                            }
                            : {} },
                        batchNumber,
                        " / ",
                        slaughterId,
                        " / ",
                        cutId)));
            })))));
};
var splitItemsToTables = function (items, limit) {
    if (items.length > limit) {
        return [
            {
                items: items.slice(0, limit)
            },
            {
                items: items.slice(limit)
            }
        ];
    }
    return [
        {
            items: items
        }
    ];
};
var MeatItems = function (_a) {
    var items = _a.items, id = _a.id;
    var itemTables = splitItemsToTables(items, 13);
    return (react_1.default.createElement(Div_1.default, { id: id, styles: {
            backgroundColor: 'black',
            fontFamily: 'Skatta Sans Regular',
            fontSize: '20px',
            height: '1920px',
            width: '100%',
            color: 'white',
            backgroundImage: "url(".concat(index_1.default.blackBoard, ")")
        } },
        react_1.default.createElement(material_1.Grid, { container: true, direction: 'row', justifyContent: 'center', style: { padding: '15px' }, spacing: 2 }, itemTables.length > 1 ? (react_1.default.createElement(react_1.Fragment, null, itemTables.map(function (_a, index) {
            var currentItems = _a.items;
            return (react_1.default.createElement(ItemTable, { key: "table-".concat(index), items: currentItems, tablesCount: itemTables.length, tableIndex: index }));
        }))) : (react_1.default.createElement(ItemTable, { key: 'table-full-width', items: items })))));
};
exports.default = MeatItems;
//# sourceMappingURL=MeatItems.js.map